import { jsxs as s, jsx as o } from "react/jsx-runtime";
const i = ({ className: r, width: t = "18", height: e = "18" }) => /* @__PURE__ */ s(
  "svg",
  {
    className: r,
    width: t,
    height: e,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    fill: "none",
    children: [
      /* @__PURE__ */ o(
        "path",
        {
          d: "M0.75 9C0.75 9 3.75 3 9 3C14.25 3 17.25 9 17.25 9C17.25 9 14.25 15 9 15C3.75 15 0.75 9 0.75 9Z",
          stroke: "currentColor",
          strokeOpacity: "0.75",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ o(
        "path",
        {
          d: "M9 11.25C10.2427 11.25 11.25 10.2427 11.25 9C11.25 7.75732 10.2427 6.75 9 6.75C7.75732 6.75 6.75 7.75732 6.75 9C6.75 10.2427 7.75732 11.25 9 11.25Z",
          stroke: "currentColor",
          strokeOpacity: "0.75",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    ]
  }
);
export {
  i as default
};
